
import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";

import {
  verifyResetPassword,
  VerifyResetPasswordRequest,
} from "@/api";
import { useUIStore } from "stores/ui.store";

const useVerifyResetPassword = () => {
  const { replace } = useRouter();

  const openToast = useUIStore((state) => state.actions.toast.openToast);

  return useMutation({
    mutationFn: (body: VerifyResetPasswordRequest) => {
      return verifyResetPassword(body);
    },
    onSuccess: (_, { email, code }) => {
      replace(`/auth/reset-password?email=${email}&code=${code}`);
    },
    onError: (error) => {
      const customError = error as any;

      openToast({ message: customError.response.data.message, variant: "error" });
    },
  });
};

export { useVerifyResetPassword };
